<template>
    <div class="animated fadeIn vld-parent" style="height: 100%; background-color: white">
        <b-row style="padding-top: 2.75rem; padding-left: 30px; padding-right: 30px">
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Einstellungen</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col md="6">
                                <b-form-group description="Bestimmt ob die Standartkontrolldarstellung auf dem Tablett die Karte ist.">
                                    <label for="use_map_default">Karte als Standart verwenden ?</label>
                                    <b-form-select class="form-control" id="use_map_default" v-model="settings.use_map_default.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group description="Bestimmt ob auf dem Tablett die Authentifizierung per NFC vorausgesetzt wird.">
                                    <label for="use_nfc">NFC verwenden ?</label>
                                    <b-form-select class="form-control" id="use_nfc" v-model="settings.use_nfc.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group description="Bestimmt ob Mängel an Extern vergeben werden können.">
                                    <label for="use_extern">Vergabe an Extern ?</label>
                                    <b-form-select class="form-control" id="use_extern" v-model="settings.use_extern.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group description="Bestimmt ob GPS-Koordinaten währen einer Kontrolle gesammelt werden sollen.">
                                    <label for="collect_gps">Koordinaten sammeln ?</label>
                                    <b-form-select class="form-control" id="collect_gps" v-model="settings.collect_gps.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group description="Bestimmt ob der Tagesbericht mitgeführt werden soll.">
                                    <label for="enable_timetracking">Tagesbericht führen ?</label>
                                    <b-form-select class="form-control" id="enable_timetracking" v-model="settings.enable_timetracking.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group description="Bestimmt ob die erste und letzte Leerzeit verteilt werden soll.">
                                    <label for="distribute_equally">Leerzeit verteilen ?</label>
                                    <b-form-select class="form-control" id="distribute_equally" v-model="settings.timetracking_distribute.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-row>
                                    <b-col>
                                        <b-form-group description="Standart Leistungsart für erfasste Zeitabschnitte">
                                            <label >Standart Leistungsart</label>
                                            <b-form-input class="black" type="text" placeholder="Leistungsart" v-model="settings.timetracking_lear.value" disabled>
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-button variant="success" v-on:click="onSelectLear" style="margin-top: 30px" class="px-4 float-right mr-3">Leistungsart auswählen</b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form-group description="Bestimmt ob erfasste Mängel auch an BIS-Office übertragen werden sollen.">
                                    <label for="bis_office">An BIS-Office übertragen ?</label>
                                    <b-form-select class="form-control" id="bis_office" v-model="settings.bis_office.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group v-if="settings.bis_office.value === 'true' && !this.isAv" description="Die Mitarbeitergruppe des Mangels, damit Aufgaben in BIS-Office angezeigt werden können. Ähnlich wie bei der Straßenkontrolle/Spielplatzkontrolle.">
                                    <label for="migr">Mitarbeitergruppe ?</label>
                                    <b-form-input class="black" type="text" placeholder="Mitarbeitergruppe" v-model="settings.migr.value">
                                    </b-form-input>
                                </b-form-group>
                              <b-form-group v-if="settings.bis_office.value === 'true' && this.isAv" description="Die Mitarbeitergruppe des Mangels, damit Aufgaben in BIS-Office angezeigt werden können. Ähnlich wie bei der Straßenkontrolle/Spielplatzkontrolle.">
                                <label for="migr">Mitarbeitergruppe ?</label>
                                <b-form-select class="form-control" v-model="settings.migr.value" :options="possibleMigrs" value-field="bis_id"
                                               text-field="name">
                                  <template #first>
                                    <b-form-select-option :value="null" disabled>-- Bitte waehlen --</b-form-select-option>
                                  </template>

                                </b-form-select>
                              </b-form-group>
                                <b-form-group v-if="settings.bis_office.value === 'true' && !this.isAv" description="Falls Mangeldaten nur nachrichtlich an BIS-Office gesendet werden, müssen Mängel weiterhin über die Baumkontrolle beplant werden.">
                                    <label for="information_purposes_only">Nur nachrichtlich ?</label>
                                    <b-form-select class="form-control" id="information_purposes_only" v-model="settings.information_purposes_only.value" :options="selects"></b-form-select>
                                </b-form-group>
                                <b-form-group v-if="settings.bis_office.value === 'true' && settings.information_purposes_only.value === 'false'" description="Bestimmt ob erfasste Mängel direkt an BIS-Office gesendet werden, oder manuell in der Baumkontrolle (oder Tablett) nach BIS-Office gesendet werden müssen.">
                                    <label for="direct">Direktversand ?</label>
                                    <b-form-select class="form-control" id="direct" v-model="settings.direct.value" :options="selects"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button variant="success" v-on:click="onSave" class="px-4 float-right mr-3">Speichern</b-button>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";

    export default {
        name: "settings",
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/bk_settings'
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                settings: {
                    use_map_default: {
                        id: "use_map_default",
                        value: "false",
                    },
                    use_nfc: {
                        id: "use_nfc",
                        value: "false",
                    },
                    bis_office: {
                        id: "bis_office",
                        value: "false",
                    },
                    information_purposes_only: {
                        id: "information_purposes_only",
                        value: "false",
                    },
                    direct: {
                        id: "direct",
                        value: "false",
                    },
                    migr: {
                        id: "migr",
                        value: "",
                    },
                    use_extern: {
                        id: "use_extern",
                        value: "false",
                    },
                    collect_gps: {
                        id: "collect_gps",
                        value: "false",
                    },
                    enable_timetracking: {
                      id: "enable_timetracking",
                      value: "false",
                    },
                    timetracking_distribute: {
                        id: "timetracking_distribute",
                        value: "false",
                    },
                    timetracking_lear: {
                        id: "timetracking_lear",
                        value: "",
                    }
                },
                isAv: false,
                possibleMigrs: [],
                selects: [
                    { value: "false", text: 'Nein' },
                    { value: "true", text: 'Ja' },
                ],
                loader: undefined,
            }
        },
        methods: {
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    for (let i = 0; i < response.body.settings.length; i++) {
                        if (this.settings[response.body.settings[i].id] !== undefined) {
                            this.settings[response.body.settings[i].id].value = response.body.settings[i].value
                        }
                    }
                    if (this.settings.timetracking_lear.value !== "") {
                        let splits = this.settings.timetracking_lear.value.split("||");
                        this.settings.timetracking_lear.value = splits[2];
                    }
                    this.isAv = response.body.is_av_active;
                    this.possibleMigrs = response.body.possible_migrs;
                    console.log(this.isAv)
                    console.log(this.possibleMigrs)
                } else {
                    console.log(response);
                }
            },
            onSave() {
                if (this.settings.bis_office.value === "true" && this.settings.migr.value === "") {
                    this.$bvToast.toast('Bitte geben Sie eine valid Mitarbeitergruppe an falls Mängel an BIS-Office übertragen werden sollen.', {
                        title: 'Achtung',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                let req = [];
                for (let prop in this.settings) {
                    if (Object.prototype.hasOwnProperty.call(this.settings, prop)) {
                        req.push(this.settings[prop])
                    }
                }
                this.showLoader();
                this.$http.post(
                    Server_URL + '/baumkontrolle/bk_settings',
                    req
                ).then(this.responseOkPost, this.responseError)
            },
            responseOkPost(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.$bvToast.toast('Die Änderungen wurden erfolgreich gespeichert.', {
                        title: 'Gespeichert',
                        variant: 'success',
                        solid: true
                    })
                } else {
                    console.log(response);
                }
            },
            onSelectLear() {
                this.$router.push("/config/lear");
            }
        }
    }
</script>

<style scoped>

</style>
